import {
  FETCH_HOMOLOGATION_SEMI_TRAILER_INIT,
  FETCH_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  FETCH_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  SAVE_HOMOLOGATION_SEMI_TRAILER_INIT,
  SAVE_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  SAVE_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  RESET_HOMOLOGATION_SEMI_TRAILER,
  FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_INIT,
  FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_INIT,
  FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  RESET_MODAL_FILE,
  FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_SUCCESS,
  FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_FAILURE,
  FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_INIT
} from './types';
import API from './api';

/* Actions Creators */

export function resetModalFileSemiTrailer() {
  return {
    type: RESET_MODAL_FILE,
  };
}

export function resetHomologationSemiTrailer() {
  return {
    type: RESET_HOMOLOGATION_SEMI_TRAILER,
  };
}

/* Get Homologations */

function fetchApiSuccess(data) {
  return {
    type: FETCH_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function fetchApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_HOMOLOGATION_SEMI_TRAILER_FAILURE,
    payload: error,
  };
}

function fetchApiInit() {
  return {
    type: FETCH_HOMOLOGATION_SEMI_TRAILER_INIT,
  };
}

export function fetchHomologationSemiTrailerApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(group, tags);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}


/* Get Homologations no loading */

function fetchApiNoLoadingSuccess(data,concat) {
  return {
    type: FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  console.log(error)
  return {
    type: FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_FAILURE,
    payload: error,
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_INIT,
  };
}

export function fetchHomologationSemiTrailerApiNoLoadingApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* Homologation Save (Async) */

function saveApiSuccess(data) {
  return {
    type: SAVE_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function saveApiFailure(error) {
  return {
    type: SAVE_HOMOLOGATION_SEMI_TRAILER_FAILURE,
    error: error,
  };
}

function saveApiInit() {
  return {
    type: SAVE_HOMOLOGATION_SEMI_TRAILER_INIT,
  };
}

export function handleHomologationSemiTrailer(data) {
  return async (dispatch) => {
    dispatch(saveApiInit());
    try {
      const resp = await API.data.handleHomologation(data);
      return dispatch(saveApiSuccess(resp));
    } catch (error) {
      return dispatch(saveApiFailure(error));
    }
  };
}

/* get download file */

function fetchDownloadApiSuccess(data) {
  return {
    type: FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function fetchDownloadApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE,
    payload: error,
  };
}

function fetchDownloadApiInit() {
  return {
    type: FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_INIT,
  };
}

export function fetchHomologationSemiTrailerDownloadApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchDownloadApiInit());
    try {
      let data = await API.data.handleHomologationDownload(group, tags);
      dispatch(fetchDownloadApiSuccess(data));
    } catch (error) {
      dispatch(fetchDownloadApiFailure(error));
    }
  };
}

/* post download fille */

function fetchUploadApiSuccess(data) {
  return {
    type: FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function fetchUploadApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE,
    payload: error,
  };
}

function fetchUploadApiInit() {
  return {
    type: FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_INIT,
  };
}

export function fetchHomologationSemiTrailerUploadApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchUploadApiInit());
    try {
      let data = await API.data.handleHomologationUpload(group, tags);
      dispatch(fetchUploadApiSuccess(data));
    } catch (error) {
      dispatch(fetchUploadApiFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/homologation_semi_trailer/index.js